<template>
  <form @submit.prevent="submit">
    <FormPackageSelect
      v-model="fields.packageId"
      :packages="packages"
      :plan-term="1"
      :disabled="isSubmitting"
    />
    <div class="form-buttons">
      <Btn variant="primary" type="submit" :disabled="!isSubmittable" :loading="isSubmitting">
        {{ $t("global.resize") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { computed, reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import FormPackageSelect from "@/components/display/form/FormPackageSelect";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { cloudServerResize as validationRules } from "leatherman-js/utils/validations/forms";

export default {
  name: "CloudServerResizeForm",
  props: {
    packages: {
      type: Array,
      required: true,
    },
    server: {
      type: Object,
      required: true,
    },
  },
  components: {
    Btn,
    FormPackageSelect,
  },
  setup(props, { root }) {
    const isSubmitting = ref(false);
    const errors = ref(null);
    const fields = reactive({ packageId: props.server.package.id });
    const { validator } = useValidator();
    const validation = validator(
      fields,
      validationRules,
      {},
      {
        term: {
          required: root.$t("validation.package-required"),
        },
      }
    );
    const isSubmittable = computed(
      () => !isSubmitting.value && Number(fields.packageId) !== props.server.package.id
    );
    const selectedPackage = computed(() =>
      props.packages.list.find((item) => item.id === fields.packageId)
    );

    const submit = () => {
      errors.value = null;

      validation
        .validate()
        .then(() => {
          isSubmitting.value = true;
          store
            .dispatch("cloudServers/resize", {
              id: props.server.id,
              data: {
                packageId: fields.packageId,
              },
            })
            .then(() => {
              store.dispatch("toasts/addToast", {
                variant: "info",
                message: root.$t("toasts.cloud-server-resize-message", {
                  name: props.server.description,
                  pack: selectedPackage.value.label,
                }),
              });
              root.$router.push({ name: "cloud-servers" });
            })
            .catch(() => {
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: root.$t("toasts.cloud-server-resize-error-message", {
                  name: props.server.description,
                  pack: selectedPackage.value.label,
                }),
              });
            })
            .finally(() => {
              isSubmitting.value = false;
            });
        })
        .catch(() => {});
    };

    return {
      errors,
      fields,
      isSubmitting,
      submit,
      validation,
      isSubmittable,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
</style>
